<template>
  <div class="part-substitute--card-list">
    <div v-if="isEmpty">{{ $t('empty_data') }}</div>
    <div v-for="(collect, substitute_type) in items" :key="substitute_type">
      <h3 style="display: inline-block;">
        <Icon :type="icons[substitute_type]" /> {{ $t(`part.${substitute_type}`) }}
        <Tooltip
          :content="substitute_type === 'mutual_substitute' ? $t('part.substitution.L1') : $t('part.substitution.L2')"
          max-width="200">
          <Icon type="md-help-circle" />
        </Tooltip>
      </h3>
      <PartInfoCard v-for="item in collect" :key="item.id"
        :name="`${item.manufacturer_part.mpn || ''} ${item.manufacturer_part.brand || ''}`"
        :specification="item.manufacturer_part.specification"
        :part-number="item.manufacturer_part.part_identity ? item.manufacturer_part.part_identity.part_number : null"
        :part-id="item.manufacturer_part.id"
        :part-state="item.manufacturer_part.moderation_state"
        :part-type="item.manufacturer_part.component_type">
      </PartInfoCard>
    </div>
  </div>
</template>

<script>
import PartInfoCard from '@/view/part/components/widgets/part-info-card'
export default {
  name: 'PartSubstituteCardList',
  components: {
    PartInfoCard
  },
  computed: {
    isEmpty () {
      return Object.keys(this.items).length === 0
    }
  },
  props: {
    items: {
      type: Object,
      required: true
    },
    icons: Object
  }
}
</script>

<style>

</style>
